// app/actions/geocode.ts
export type GeocodeResult = { lat: number; lon: number } | null

export async function geocodeAddress(address: string): Promise<GeocodeResult> {
  try {
    const res = await fetch(
      `/api/geocode?address=${encodeURIComponent(address)}`,
      { cache: 'no-store' }
    )
    if (!res.ok) {
      console.error('geocode API error', res.status, await res.text())
      return null
    }
    const data = await res.json() as { found?: boolean; ok?: boolean; lat?: number; lng?: number; lon?: number; error?: string }
    // Handle found (API) or ok (legacy) format
    const ok = data.found ?? data.ok
    if (ok && typeof data.lat === 'number' && (typeof data.lng === 'number' || typeof data.lon === 'number')) {
      return { lat: data.lat, lon: data.lng ?? data.lon! }
    }
    return null
  } catch (err) {
    console.error('geocode fetch failed', err)
    return null
  }
}
